import { z } from 'zod';

export const reservationSchema = z.object({
  nome: z.string()
    .trim()
    .min(2, 'Il nome deve contenere almeno 2 caratteri')
    .max(100, 'Il nome non può superare 100 caratteri')
    .regex(/^[a-zA-ZàèéìòùÀÈÉÌÒÙ\s'-]+$/, 'Il nome contiene caratteri non validi'),
  
  email: z.string()
    .trim()
    .email('Inserisci un indirizzo email valido')
    .max(255, 'L\'email non può superare 255 caratteri')
    .toLowerCase(),
  
  telefono: z.string()
    .trim()
    .regex(/^\+?[0-9\s-]{6,15}$/, 'Inserisci un numero di telefono valido (6-15 cifre)'),
  
  persone: z.number()
    .int('Il numero di persone deve essere un numero intero')
    .min(1, 'Minimo 1 persona')
    .max(20, 'Massimo 20 persone'),
  
  data: z.string()
    .min(1, 'Seleziona una data'),
  
  ora: z.string()
    .min(1, 'Seleziona un orario')
    .regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato orario non valido'),
  
  note: z.string()
    .max(500, 'Le note non possono superare 500 caratteri')
    .optional()
    .default('')
});

export type ReservationFormData = z.infer<typeof reservationSchema>;
